/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_QuestionInputs */

const en_us2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How sore are your muscles today?`)
};

const pt_br2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a dor muscular hoje?`)
};

const es_419_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto dolor muscular tienes hoy?`)
};

const pt_pt2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como está a dor muscular hoje?`)
};

const fr_fr2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment sont tes courbatures aujourd'hui ?`)
};

const de_de2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie stark ist dein Muskelkater heute?`)
};

const it_it2_today_checkin_question = /** @type {(inputs: Today_Checkin_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'è l'indolenzimento muscolare oggi?`)
};

/**
* | output |
* | --- |
* | "How sore are your muscles today?" |
*
* @param {Today_Checkin_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_question = /** @type {((inputs?: Today_Checkin_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_question(inputs)
	if (locale === "es-419") return es_419_today_checkin_question(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_question(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_question(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_question(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_question(inputs)
	return en_us2_today_checkin_question(inputs)
});
export { today_checkin_question as "today.checkin_question" }